import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

export const useIsCompanyHaveSafes = ({ companyId }: { companyId: string }) => {
  const queryClient = useQueryClient();
  const {
    data: isCompanyHaveSafes,
    isLoading,
    refetch,
  } = useAppQuery<string, HttpException>({
    queryKey: [QueryKey.IS_COMPANY_HAVE_SAVES, companyId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'safes', 'is-company-have-safes'],
      }),
    enabled: !!companyId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.IS_COMPANY_HAVE_SAVES] });
  }, [queryClient]);

  return {
    invalidateQuery,
    isCompanyHaveSafes,
    isLoading,
    refetch,
  };
};
